import React, {Fragment} from 'react'
import { useQuery } from '@apollo/react-hooks';
import { GET_OWNED_TILES } from '../services/graphql';
import _ from 'lodash';

import ItemPreview from './ItemPreview';
const OwnedTiles = ({item, onRemoveItem, onSelectTile,}) => {
    const { data, error, loading } = useQuery(GET_OWNED_TILES, {
        variables: {
            avatarItemId: item.id
        },
        fetchPolicy: 'network-only'
    });
    if (loading) {
        return <p>Loading</p>
    }
    if (error) {
        return <p>Something went wrong</p>
    }
    if (data) {
        return (
            <Fragment>
            <li className="store__tile-heading">Choose an owned style for this {item.type}.</li>
            {
                _.map(item.url, (tile, index) => {
                    if(item.price === 0 || data.tilesForItem.includes(index + 1)) {
                    const tileNumber = index + 1;
                    const tileSelected = Number(item.tile) === tileNumber;

                    return (
                        <li key={`tile-${item.id}-${index}`} onClick={() => onSelectTile(tileNumber, true)} className={`store__item ${tileSelected ? 'store__item--wearing' : ''}`}>
                            <p className="store__item-name">Style {tileNumber}</p>
                            {item.type === 'backdrop' ? <img src={tile} className="store__backdrop-thumbnail" alt="Backdrop" /> : <ItemPreview src={tile} className="store__item-img" />}
                            <span className="store__item-selected" aria-hidden="true">{tileSelected ? '✓' : ''}</span>
                            <p className="store__item-status store__item-status--owned"><span aria-hidden="true">✓</span> Owned</p>
                        </li>
                    )}
                    return null
                })
            }
            {
                item.wearing ? 
                <li onClick={() => onRemoveItem()} className={`store__item store__item--remove ${Number(item.tile) === -1 ? 'store__item--wearing' : ''}`}>
                    <span className="store__item-img store__item-img--remove">Remove</span>
                </li> :
                null
            }
            </Fragment>
        )
    }
    return null
}

export default OwnedTiles
